export default __webpack_public_path__ + "static/media/show5.65fa096b.jpeg";